import { Component } from '@angular/core';

@Component({
  selector: 'app-boq-bidding-wrapper',
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class BoqBiddingWrapperComponent {}
